import confetti, {type Options} from 'canvas-confetti';

export function launchConfetti(element: HTMLElement, options?: {position?: string; dataTestid?: string; confettiOptions: Partial<Options>}): void {
    const canvas = document.createElement('canvas');

    if (!element) {
        return;
    }
    element.style.position = options?.position || 'relative';

    canvas.style.position = 'absolute';
    canvas.style.top = '0px';
    canvas.style.left = '0px';
    canvas.style.width = element?.clientWidth ? `${element.clientWidth}px` : 'inherit';
    canvas.style.height = element?.clientHeight ? `${element.clientHeight}px` : 'inherit';
    canvas.setAttribute('data-testid', options?.dataTestid || 'canvas-confetti');

    element?.appendChild(canvas);

    const canvasConfetti = confetti.create(canvas, {
        resize: true,
    });

    canvasConfetti(options?.confettiOptions)?.then(() => {
        canvasConfetti.reset();
        element?.removeChild(canvas);
    });
}
